import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61044b21"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Keresés ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Ingyenes")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("500 Ft")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("1000 Ft")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("2000 Ft")
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Nincs")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Életkorod")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("14+")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("16+")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("18+")
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { class: "flex ion-margin-bottom" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "ion-no-margin ion-margin-end" }, " Csak amit követek ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ha bekapcsolod, csak azok a helyek jelennek meg, amiket követsz.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_FatButton = _resolveComponent("FatButton")!
  const _component_FatButtonContainer = _resolveComponent("FatButtonContainer")!
  const _component_FatButtonFloat = _resolveComponent("FatButtonFloat")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.placeSearch().modalOpen,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": _ctx.$root.$refs.mainRouterOutlet.$el,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_chip, {
            onClick: _cache[0] || (_cache[0] = 
                    () => {
                        _ctx.openedFilter = 'name';
                        _ctx.focusOn('nameInput');
                    }
                ),
            color: _ctx.name.length > 0 ? 'primary' : 'dark',
            outline: _ctx.openedFilter == 'name'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode("Név" + _toDisplayString(_ctx.name.length > 0 ? ": " + _ctx.caps(_ctx.name) : ""), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "outline"]),
          _createVNode(_component_ion_chip, {
            onClick: _cache[1] || (_cache[1] = 
                    () => {
                        _ctx.openedFilter = 'town';
                        _ctx.focusOn('townInput');
                    }
                ),
            color: _ctx.town.length > 0 ? 'primary' : 'dark',
            outline: _ctx.openedFilter == 'town'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode("Város" + _toDisplayString(_ctx.town.length > 0 ? ": " + _ctx.caps(_ctx.town) : ""), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "outline"]),
          _createVNode(_component_ion_chip, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openedFilter = 'price')),
            color: _ctx.price != -1 ? 'primary' : 'dark',
            outline: _ctx.openedFilter == 'price'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode("Belépő ára" + _toDisplayString(_ctx.price == -1
                            ? ""
                            : ": " + (_ctx.price == 0 ? "Ingyenes" : _ctx.price + " Ft")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "outline"]),
          _createVNode(_component_ion_chip, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openedFilter = 'age')),
            color: _ctx.age != -1 ? 'primary' : 'dark',
            outline: _ctx.openedFilter == 'age'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode("Korhatár" + _toDisplayString(_ctx.age == -1 ? "" : _ctx.age == 0 ? " nélkül" : ": " + _ctx.age + "+"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "outline"]),
          _createVNode(_component_ion_chip, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openedFilter = 'only-following')),
            color: _ctx.onlyFollowing ? 'primary' : 'dark',
            outline: _ctx.openedFilter == 'only-following'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode("Követés" + _toDisplayString(_ctx.onlyFollowing ? ": Csak követett" : ""), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "outline"]),
          _hoisted_3,
          (_ctx.openedFilter == 'name')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("form", {
                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submission($event, 'town')), ["prevent"])),
                    class: "formfix"
                  }, [
                    _createVNode(_component_ion_input, {
                      ref: "nameInput",
                      placeholder: "Kezdd el írni a rendezvény nevét",
                      modelValue: _ctx.name,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                      debounce: "100",
                      onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkNext($event, 'town')))
                    }, null, 8, ["modelValue"])
                  ], 32),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.trash,
                    class: "trash-icon",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.name = ''))
                  }, null, 8, ["icon"])
                ]),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.openedFilter == 'town')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", {
                    onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submission($event, 'date')), ["prevent"])),
                    class: "formfix"
                  }, [
                    _createVNode(_component_ion_input, {
                      ref: "townInput",
                      placeholder: "Kezdd el írni a keresett várost",
                      modelValue: _ctx.town,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.town) = $event)),
                      debounce: "100",
                      onKeypress: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkNext($event, 'date')))
                    }, null, 8, ["modelValue"])
                  ], 32),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.trash,
                    class: "trash-icon",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.town = ''))
                  }, null, 8, ["icon"])
                ]),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          (_ctx.openedFilter == 'price')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ion_range, {
                    color: "primary",
                    pin: true,
                    min: "0",
                    max: "5000",
                    debounce: "100",
                    modelValue: _ctx.price,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.price) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.trash,
                    class: "trash-icon",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.price = -1))
                  }, null, 8, ["icon"])
                ]),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.price = 0))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.price = 500))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.price = 1000))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.price = 2000))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.openedFilter == 'age')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_ion_range, {
                    color: "primary",
                    pin: true,
                    min: "10",
                    max: "18",
                    debounce: "100",
                    modelValue: _ctx.age,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.age) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.trash,
                    class: "trash-icon",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.age = -1))
                  }, null, 8, ["icon"])
                ]),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.age = 0))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.age = 18))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.age = 14))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.age = 16))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_chip, {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.age = 18))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.openedFilter == 'only-following')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_ion_toggle, {
                    class: "ion-margin-end",
                    checked: _ctx.onlyFollowing,
                    onIonChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.followingChange($event)))
                  }, null, 8, ["checked"]),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.trash,
                    class: "trash-icon",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onlyFollowing = false))
                  }, null, 8, ["icon"])
                ]),
                _hoisted_26
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.clearAlertShown,
            header: "Törlés",
            message: "Törlöd az összes szűrőt?",
            buttons: _ctx.clearAlertButtons,
            onDidDismiss: _cache[28] || (_cache[28] = ($event: any) => (_ctx.clearAlert(false)))
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_component_FatButtonFloat, { pushup: true }, {
            default: _withCtx(() => [
              _createVNode(_component_FatButtonContainer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FatButton, {
                    icon: _ctx.trash,
                    secondary: true,
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.clearAlert(true)))
                  }, null, 8, ["icon"]),
                  _createVNode(_component_FatButton, {
                    icon: _ctx.searchOutline,
                    text: "Keresés",
                    onClick: _ctx.dismiss
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}